<template>
  <div class="ad-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加广告</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           :title="title"
           @on-ok="createAd('adValidate')"
           :loading="loading">
      <Form :model="ad"
            ref="adValidate"
            :rules="adValidate"
            action="javascript:void(0)">
        <FormItem label="广告位"
                  label-position="top">
          <Select v-model="ad.pos_id"
                  clearable
                  filterable
                  placeholder="选择广告位">
            <Option v-for="item in adposList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="标题"
                  prop="title">
          <Input v-model="ad.title"
                 placeholder="输入标题..."></Input>
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="ad.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="670"
                        :autoCropHeight="270"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif，建议H5端图片尺寸:670*270，大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="跳转类型">
          <Select v-model="
                  ad.link_type"
                  :style="{'width':'240px'}">
            <Option :value="0"
                    :key="0">H5</Option>
            <Option :value="1"
                    :key="1">商城小程序</Option>
            <!-- <Option :value="2"
                    :key="2">定制小程序</Option>
            <Option :value="3"
                    :key="3">盲盒小程序</Option>-->
            <Option :value="4"
                    :key="4">兑换商城小程序</Option>
            <!-- <Option :value="5"
                    :key="5">非遗地图小程序</Option> -->
          </Select>
        </FormItem>
        <FormItem label="跳转内容">
          <Select v-model="
                  ad.link_content"
                  :style="{'width':'240px'}"
                  @on-change="LinkChange">
            <Option :value="0"
                    :key="0">普通</Option>
            <Option :value="1"
                    :key="1">商品</Option>
            <Option :value="2"
                    :key="2">匠人</Option>
          </Select>
        </FormItem>
        <FormItem label="链接地址">
          <Input v-model="ad.url"
                 placeholder="输入外链..."></Input>
        </FormItem>
        <FormItem label="开始时间"
                  prop="lasttime">
          <DatePicker v-model="ad.lasttime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间"
                      style="width: 200px"
                      @on-change="changeDateOne"></DatePicker>
        </FormItem>
        <FormItem label="结束时间"
                  prop="lowertime">
          <DatePicker v-model="ad.lowertime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="结束时间"
                      style="width: 200px"
                      @on-change="changeDateTwo"></DatePicker>
        </FormItem>
        <FormItem label="省-市-县"
                  label-position="top">
          <Select v-model="ad.area1"
                  placeholder="省"
                  @on-change="shengChange">
            <Option v-for="item in shengList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="ad.area2"
                  placeholder="市"
                  @on-change="shiChange">
            <Option v-for="item in shiList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="ad.area3"
                  placeholder="县">
            <Option v-for="item in quList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="排序"
                  prop="sort">
          <Input v-model="ad.sort"
                 placeholder="输入顺序..."></Input>
        </FormItem>
        <FormItem label="状态"
                  label-position="top">
          <RadioGroup v-model="ad.status">
            <Radio label="1">正常</Radio>
            <Radio label="0">禁用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
  name: "ad-list",
  data () {
    const validateSelectPos = (rule, value, callback) => {
      if (
        this.ad.pos_id === "" ||
        this.ad.pos_id === null ||
        this.ad.pos_id === 0
      ) {
        callback(new Error("请选择广告位"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: true,
      cateList: [], // 请求分类
      formItem: [],
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "名称",
          key: "title",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "开始时间",
          key: "starttime",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "结束时间",
          key: "endtime",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "封面图",
          key: "thumb",
          fixed: "left",
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            // let thumbImg =
            //   params.row.thumb.indexOf("https") > -1
            //     ? zUrl + params.row.thumb
            //     : params.row.thumb;
            let thumbImg = params.row.thumb;
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: thumbImg
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      title: "添加广告",
      tablelist: [],
      adposList: [],
      thumblist: [],
      shengList: {},
      shiList: {},
      quList: {},
      ad: {
        status: "1",
        thumb: "",
        sort: 0,
        link_type: 0,
        link_content: 0,
        url: ""
      },
      showModalStatus: false,
      adValidate: {
        pos_id: [
          { required: true, validator: validateSelectPos, trigger: "change" }
        ],
        title: [
          { required: true, message: "广告名称必须填写", trigger: "blur" }
        ]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getAdposList();
    this.getShengList();
  },
  components: {
    UploadThumb
  },
  methods: {
    getTableList: function () {
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.ad.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.count;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getAdposList: function () {
      var params = { page: 1, size: 1000 };
      this.$api.adpos.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.adposList = res.result.list;
        }
      });
      return;
    },
    changeDateTwo (val) {
      this.ad.endtime = val;
    },
    changeDateOne (val) {
      this.ad.starttime = val;
    },

    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    LinkChange: function (value) {
      if (this.ad.link_type == "1" && value == "1") {
        this.ad.url = "pages/goods/detail/index?goodsId=";
      } else if (this.ad.link_type == "1" && value == "2") {
        this.ad.url = "pages/artisan/detail/index?tradesmanId=";
      } else {
        this.ad.url = "";
      }
    },
    // 展开添加
    showModel () {
      this.title = "添加广告";
      this.adid = "";
      this.$refs["adValidate"].resetFields();
      this.thumblist = [];
      this.ad = {
        status: "1",
        thumb: "",
        sort: 0,
        link_type: 0,
        link_content: 0,
        url: ""
      },
        this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function (index) {
      this.title = "修改广告";
      this.adid = index;
      this.thumblist = [];
      this.$refs["adValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      // 取信息
      this.$api.ad.detail({ ad_id: index }).then(res => {
        if (res.code == 200) {
          this.ad = res.result;
          this.thumblist.push({
            name: this.ad.thumb,
            url: this.ad.thumb,
            status: "finished"
          });
          this.ad.status = res.result.status.toString();
          this.ad.lasttime = res.result.starttime;
          this.ad.lowertime = res.result.endtime;
          //省市区三个下拉框
          this.shiList = this.ad.shiList;
          this.quList = this.ad.quList;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加
    createAd (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.ad.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          }
          if (this.adid == null || this.adid == 0) {
            this.$api.ad.create(this.ad).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.ad.id = this.adid;
            this.$api.ad.edit(this.ad).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.ad.remove({ ad_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    }
  }
};
</script>
